import { render, staticRenderFns } from "./radar-echart.vue?vue&type=template&id=2fbda2bf&"
import script from "./radar-echart.vue?vue&type=script&lang=js&"
export * from "./radar-echart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports